import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
export var authenticate = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(storage, authenticators) {
    var credential, _i2, authenticator, credentialA;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return storage.load();

          case 2:
            credential = _context.sent;

            if (!(credential && !storage.skipInitialLoad)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", credential);

          case 5:
            if (!(authenticators.length > 0)) {
              _context.next = 19;
              break;
            }

            _i2 = 0;

          case 7:
            if (!(_i2 < authenticators.length)) {
              _context.next = 19;
              break;
            }

            authenticator = authenticators[_i2];
            _context.next = 11;
            return authenticator();

          case 11:
            credentialA = _context.sent;

            if (!credentialA) {
              _context.next = 16;
              break;
            }

            if (!credential) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", {
              key: credential.key,
              user: _extends({}, credential.user, credentialA.user)
            });

          case 15:
            return _context.abrupt("return", credentialA);

          case 16:
            _i2++;
            _context.next = 7;
            break;

          case 19:
            return _context.abrupt("return", undefined);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function authenticate(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();